import { render } from "./AlsoBlock.vue?vue&type=template&id=2b97bea1&scoped=true"
import script from "./AlsoBlock.vue?vue&type=script&lang=js"
export * from "./AlsoBlock.vue?vue&type=script&lang=js"

import "./AlsoBlock.vue?vue&type=style&index=0&id=2b97bea1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97bea1"]])

export default __exports__